exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-image[data-v-7e0c23f6]{background-image:url(/images/layouts/Widget.png);height:auto;background-position:50%;background-repeat:no-repeat;background-size:cover}", ""]);

// exports
